export const API_HEADERS = {
  acceptLanguage: "Accept-Language",
  countryCode: "X-Country-Code",
  language: "X-Language",
  fallbackLanguage: "X-Fallback-Language",
  idmRoles: "X-IDM-Roles",
  preview: "X-Preview",
  authorization: "Authorization",
  siteHash: "X-Site-Hash",
  userId: "X-User-Id",
} as const;
